<template>
  <div>
    <Hero />
    <breadcrumbs :crumbs="breadcrumbs" />
    <div v-if="article" >
      <div class="knowledge-article-heading">
        {{ article.title }}
      </div>
      <div v-html="article.text" class="knowledge-article-content"></div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Hero from "@/components/knowledge/Hero";

export default {
    name: "Article",
    methods: mapActions({
        "fetch": "knowledge/articles/fetchArticle"
    }),
    computed: mapGetters({
        "article": "knowledge/articles/article",
        "breadcrumbs": "knowledge/articles/breadcrumbs"
    }),
    mounted() {
        this.fetch({slug: this.$route.params.slug});
    },
    components: { Hero }
};
</script>
<style>
.bb-view-background {
  background: var(--knowledge-background);
}
.knowledge-article-heading {
  color: var(--knowledge-article-heading-color);
  font-size: var(--knowledge-article-heading-font-size);
  font-weight: var(--knowledge-article-heading-font-weight);
  line-height: var(--knowledge-article-heading-line-height);
}
.knowledge-article-content {
  color: var(--knowledge-article-content-color);
  font-size: var(--knowledge-article-content-font-size);
  font-weight: var(--knowledge-article-content-font-weight);
  line-height: var(--knowledge-article-content-line-height);
}
</style>